/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SearchInputs */

const he_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חיפוש...`)
};

const en_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search...`)
};

/**
* | output |
* | --- |
* | "Search..." |
*
* @param {Common_SearchInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const common_search = /** @type {((inputs?: Common_SearchInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SearchInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_search(inputs)
	return en_common_search(inputs)
});